import React from 'react';
import './ReportSteps.css';
import ReviewRequiredBanner from '../../shared/ReviewRequiredBanner';
import { useReviewRequiredDatasets } from '../useReviewRequiredDatasets';
import { automationReviewNotice } from '../../../../utils/reviewRequiredNotice';
import { scheduleLabel } from '../../../../utils/scheduleLabel';
import { defaultScheduleZone } from '../../shared/ScheduleZoneField';

const ReportStepReview = ({ formData, onSetFormData, onCreate, showCreateButton = true }) => {
  // PRD-1359: repeat of the step 2 warning, under the Review title. This is the
  // last screen before Create, so it is the last chance to tell an author their
  // scheduled report will run on partial data.
  const reviewDatasets = useReviewRequiredDatasets(formData.reportDatasetIds);
  const hasReviewBanner = !!automationReviewNotice(reviewDatasets);
  const trigger = formData.trigger ?? {};
  const schedule = scheduleLabel(trigger, formData.timezone || defaultScheduleZone());

  const queryText = (formData.reportQuery || formData.queryName || '').trim();
  const deliveryParts = [];
  if (formData.reportEmailToSelf !== false) {
    deliveryParts.push(formData.userEmail && formData.userEmail.trim() ? formData.userEmail.trim() : 'Your account email');
  }
  if ((formData.reportRecipients ?? []).length > 0) {
    deliveryParts.push(...formData.reportRecipients);
  }
  const deliveryDisplay = deliveryParts.length > 0 ? deliveryParts.join(', ') : '—';

  const canCreate = !!(formData.automationName && formData.automationName.trim() && queryText);

  return (
    <div className="report-step-content">
      <h3 className={`report-step-title${hasReviewBanner ? ' report-step-title--banner' : ''}`}>Review</h3>

      <ReviewRequiredBanner
        datasets={reviewDatasets}
        variant="automation"
        className="report-review-required-banner"
      />

      <div className="report-review-card">
        <div className="report-review-row">
          <span className="report-review-label">Query</span>
          <span className="report-review-value">{queryText || '—'}</span>
        </div>
        <div className="report-review-row">
          <span className="report-review-label">Delivery</span>
          <span className="report-review-value">{deliveryDisplay}</span>
        </div>
        <div className="report-review-row">
          <span className="report-review-label">Schedule</span>
          <span className="report-review-value">
            {schedule}
          </span>
        </div>
      </div>

      <div className="report-form-field">
        <label className="report-label">Automation Name</label>
        <input
          type="text"
          className="resui-input"
          placeholder="Enter automation name"
          value={formData.automationName ?? ''}
          onChange={(e) => onSetFormData({ ...formData, automationName: e.target.value })}
        />
      </div>

      <div className="report-form-field">
        <label className="report-label">Description (Optional)</label>
        <textarea
          className="resui-textarea"
          placeholder="Describe what this automation does"
          value={formData.description ?? ''}
          onChange={(e) => onSetFormData({ ...formData, description: e.target.value })}
          rows={3}
        />
      </div>

      {(showCreateButton && (
        <div className="report-review-actions">
          <button
            type="button"
            className="report-button report-button-primary"
            disabled={!canCreate}
            onClick={onCreate}
          >
            Create automation
          </button>
        </div>
      ))}
    </div>
  );
};

export default ReportStepReview;
